import React from 'react';
import {IntegrationEmptyCard} from '../IntegrationDesign';

export default function AffiliateNetworkNoIntegrationsView(props) {
    const addIntegration = () => props.history.push({pathname: '/settings/integrations/add-affiliate-network', state: {background: props.location}});
    return <IntegrationEmptyCard title='Revenue sync · Affiliate networks' description='Synchronize conversions and revenue from your affiliate networks.' onAdd={addIntegration}
        features={['Sync revenue and conversions.', 'Receive conversions through instant notifications.', 'Stream revenue from AFD search feeds.']}/>;
}
